import React, { useState, useEffect } from 'react';
import PocketBase from 'pocketbase';
import Header from '../Header'; 
import Footer from '../Footer';

const pb = new PocketBase('https://bahcarplaza.com');

function Blogs({ view, setView, setSearchTerm, setCityFilter, setActiveTab }) {
  const [posts, setPosts] = useState([]);
  const [loading, setLoading] = useState(true);
  
  const [activePost, setActivePost] = useState(null); 
  const [isMobileReading, setIsMobileReading] = useState(false); 
  const [showAllDesktop, setShowAllDesktop] = useState(false); 

  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchPosts = async () => {
      try {
        const records = await pb.collection('blog_post').getFullList({
          sort: '-created', 
          expand: 'author' 
        });
        setPosts(records);
        if (records.length > 0) {
          setActivePost(records[0]); 
        }
      } catch (error) {
        console.error("Error fetching blogs:", error);
      } finally {
        setLoading(false);
      }
    };
    fetchPosts();
  }, []);

  const getImageUrl = (record, fileName) => {
    if (!fileName) return 'https://images.unsplash.com/photo-1492144534655-ae79c964c9d7?auto=format&fit=crop&w=1000&q=80'; 
    return `https://bahcarplaza.com/api/files/${record.collectionId}/${record.id}/${fileName}`;
  };

  const stripHtml = (htmlString) => {
    if (!htmlString) return "";
    const doc = new DOMParser().parseFromString(htmlString, 'text/html');
    return doc.body.textContent || "";
  };

  const currentIndex = activePost ? posts.findIndex(p => p.id === activePost.id) : -1;
  const nextPost = currentIndex > 0 ? posts[currentIndex - 1] : null; 
  const prevPost = currentIndex >= 0 && currentIndex < posts.length - 1 ? posts[currentIndex + 1] : null; 

  const handleNext = () => { if (nextPost) { setActivePost(nextPost); window.scrollTo({ top: 0, behavior: 'smooth' }); } };
  const handlePrev = () => { if (prevPost) { setActivePost(prevPost); window.scrollTo({ top: 0, behavior: 'smooth' }); } };

  const handleDesktopPostClick = (post) => {
    setActivePost(post);
    setShowAllDesktop(false);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  const handleMobilePostClick = (post) => {
    setActivePost(post);
    setIsMobileReading(true);
    window.scrollTo({ top: 0, behavior: 'smooth' });
  };

  return (
    <div className="min-h-screen bg-[#f4f7f6] flex flex-col font-sans">
      
      <style>
        {`
          .blog-rich-text h1, .blog-rich-text h2, .blog-rich-text h3 { color: #002f34; font-weight: 900; margin-top: 1.5em; margin-bottom: 0.5em; line-height: 1.3; }
          .blog-rich-text h1 { font-size: 2em; }
          .blog-rich-text h2 { font-size: 1.75em; }
          .blog-rich-text h3 { font-size: 1.5em; }
          .blog-rich-text p { margin-bottom: 1.2em; color: #444; font-size: 1.1rem; line-height: 1.8; }
          .blog-rich-text ul { list-style-type: disc; padding-left: 25px; margin-bottom: 1.5em; color: #444; font-size: 1.1rem; }
          .blog-rich-text ol { list-style-type: decimal; padding-left: 25px; margin-bottom: 1.5em; color: #444; font-size: 1.1rem; }
          .blog-rich-text li { margin-bottom: 0.5em; }
          .blog-rich-text a { color: #ef5e33; text-decoration: underline; font-weight: bold; }
          .blog-rich-text b, .blog-rich-text strong { font-weight: 900; color: #002f34; }
          .blog-rich-text i, .blog-rich-text em { font-style: italic; color: #555; }
          .blog-rich-text blockquote { border-left: 4px solid #ef5e33; padding-left: 15px; font-style: italic; color: #666; margin-left: 0; margin-bottom: 1.5em; background: #f9f9f9; padding: 15px; border-radius: 0 10px 10px 0; }
        `}
      </style>

      <Header view={view} setView={setView} setSearchTerm={setSearchTerm} setCityFilter={setCityFilter} setActiveTab={setActiveTab} />

      {/* ========================================================= */}
      {/* 💻 DESKTOP VIEW 💻 */}
      {/* ========================================================= */}
      <main className="hidden md:flex flex-1 max-w-[1500px] w-full mx-auto px-6 py-10 gap-10 items-start">
        
        {/* LEFT SIDEBAR */}
        <aside className="w-[30%] lg:w-[25%] flex flex-col gap-6 sticky top-24">
          <div className="bg-[#002f34] text-white p-6 rounded-3xl shadow-lg relative overflow-hidden">
            <div className="absolute top-0 right-0 w-20 h-20 bg-white opacity-5 rounded-full -mr-10 -mt-10"></div>
            <h2 className="text-2xl font-black uppercase italic relative z-10">Bah! <span className="text-[#ef5e33]">Autonauts</span></h2>
            <p className="text-gray-300 text-xs font-bold mt-2 relative z-10">Your ultimate destination for the latest automotive news.</p>
          </div>

          <div className="bg-white rounded-3xl p-5 shadow-sm border border-gray-100 flex flex-col gap-4">
            <h3 className="font-black text-[#002f34] text-lg uppercase border-b border-gray-100 pb-3 mb-1">Recent Posts</h3>
            
            {posts.slice(0, 5).map(post => (
              <div 
                key={post.id} 
                onClick={() => handleDesktopPostClick(post)}
                className={`flex items-center gap-4 p-2 rounded-xl cursor-pointer transition-all hover:bg-gray-50 ${activePost?.id === post.id && !showAllDesktop ? 'bg-[#f4f7f6] border-l-4 border-[#ef5e33]' : 'border-l-4 border-transparent'}`}
              >
                <div className="w-16 h-12 rounded-lg overflow-hidden shrink-0 shadow-sm">
                  <img src={getImageUrl(post, post.file)} alt="thumb" className="w-full h-full object-cover" />
                </div>
                <h4 className="text-xs font-bold text-[#002f34] line-clamp-2 leading-snug">{post.title}</h4>
              </div>
            ))}

            <button 
              onClick={() => { setShowAllDesktop(true); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className="mt-4 w-full py-3 border-2 border-[#002f34] text-[#002f34] rounded-xl font-black text-xs uppercase hover:bg-[#002f34] hover:text-white transition-colors cursor-pointer"
            >
              View All Posts
            </button>
          </div>
        </aside>

        {/* RIGHT CONTENT AREA */}
        <section className="w-[70%] lg:w-[75%]">
          {loading ? (
             <div className="text-center py-20 font-bold text-gray-500 bg-white rounded-3xl shadow-sm">Loading amazing content...</div>
          ) : posts.length === 0 ? (
             <div className="text-center py-20 font-bold text-gray-500 bg-white rounded-3xl shadow-sm">No blog posts found.</div>
          ) : showAllDesktop ? (
            
            /* ALL POSTS GRID (Desktop) */
            <div className="bg-white rounded-[2rem] p-8 shadow-sm border border-gray-100">
               <h2 className="text-3xl font-black text-[#002f34] uppercase mb-8 border-b-2 border-gray-100 pb-4">All <span className="text-[#ef5e33]">Articles</span></h2>
               <div className="grid grid-cols-1 lg:grid-cols-2 gap-8">
                  {posts.map((post) => (
                    <div 
                      key={post.id} 
                      onClick={() => handleDesktopPostClick(post)}
                      className="bg-white rounded-2xl shadow-sm hover:shadow-xl transition-all duration-300 border border-gray-100 overflow-hidden flex flex-col group cursor-pointer" 
                    >
                      <div className="h-48 overflow-hidden relative">
                        <img src={getImageUrl(post, post.file)} alt={post.title} className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-700" />
                      </div>
                      <div className="p-5 flex flex-col flex-1 bg-gradient-to-b from-white to-[#fcfcfc]">
                        <p className="text-gray-400 text-[10px] font-bold uppercase tracking-widest mb-2">
                          🗓️ {new Date(post.publish_date || post.created).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' })}
                        </p>
                        <h3 className="text-lg font-black text-[#002f34] leading-snug mb-2 group-hover:text-[#ef5e33] transition-colors line-clamp-2">{post.title}</h3>
                        <p className="text-gray-500 text-xs font-medium line-clamp-3 mb-4 flex-1">{stripHtml(post.content)}</p>
                        <span className="text-[#ef5e33] font-black text-[10px] uppercase tracking-widest group-hover:translate-x-1 transition-transform">Read →</span>
                      </div>
                    </div>
                  ))}
               </div>
            </div>

          ) : activePost ? (

            /* 🚨 FIXED: FULL READING VIEW (Desktop) 🚨 */
            <div className="bg-white rounded-[2rem] shadow-sm border border-gray-100 overflow-hidden">
              
              {/* Image without overlay text */}
              <div className="w-full h-[350px] lg:h-[500px] overflow-hidden bg-gray-100">
                <img src={getImageUrl(activePost, activePost.file)} alt={activePost.title} className="w-full h-full object-cover" />
              </div>
              
              <div className="p-8 lg:p-12">
                
                {/* Title below image */}
                <h1 className="text-3xl lg:text-[42px] font-black text-[#002f34] leading-tight mb-8">
                  {activePost.title}
                </h1>

                {/* Author and Date/Time side by side */}
                <div className="flex flex-wrap items-center gap-4 mb-10 border-b border-gray-100 pb-6 bg-[#fcfcfc] p-4 rounded-xl border">
                  <div className="flex items-center gap-3">
                    <div className="w-12 h-12 bg-[#002f34] rounded-full flex items-center justify-center text-white font-black text-lg shadow-md">
                       {activePost.expand?.author?.name?.charAt(0) || 'A'}
                    </div>
                    <div>
                      <p className="text-[#002f34] text-sm font-black uppercase m-0">{activePost.expand?.author?.name || 'Admin'}</p>
                      <p className="text-gray-400 text-[11px] font-bold uppercase tracking-widest m-0 mt-0.5">Author</p>
                    </div>
                  </div>
                  
                  <div className="hidden sm:block w-px h-10 bg-gray-300 mx-2"></div>
                  
                  <div>
                    <p className="text-[#002f34] text-sm font-black uppercase m-0">
                      {new Date(activePost.publish_date || activePost.created).toLocaleString('en-IN', { year: 'numeric', month: 'long', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true })}
                    </p>
                    <p className="text-gray-400 text-[11px] font-bold uppercase tracking-widest m-0 mt-0.5">Published</p>
                  </div>
                </div>

                {/* RICH TEXT RENDERER */}
                <div className="blog-rich-text" dangerouslySetInnerHTML={{ __html: activePost.content }} />
                
                {/* PREV / NEXT BUTTONS */}
                <div className="flex items-center justify-between mt-12 pt-8 border-t border-gray-100">
                  {prevPost ? (
                    <div onClick={handlePrev} className="flex flex-col cursor-pointer group w-[45%]">
                      <span className="text-gray-400 text-xs font-bold uppercase tracking-widest mb-1 group-hover:text-[#ef5e33] transition-colors">← Previous Article</span>
                      <span className="text-[#002f34] font-black text-sm truncate">{prevPost.title}</span>
                    </div>
                  ) : <div className="w-[45%]"></div>}

                  {nextPost ? (
                    <div onClick={handleNext} className="flex flex-col text-right cursor-pointer group w-[45%]">
                      <span className="text-gray-400 text-xs font-bold uppercase tracking-widest mb-1 group-hover:text-[#ef5e33] transition-colors">Next Article →</span>
                      <span className="text-[#002f34] font-black text-sm truncate">{nextPost.title}</span>
                    </div>
                  ) : <div className="w-[45%]"></div>}
                </div>

              </div>
            </div>
          ) : null}
        </section>
      </main>


      {/* ========================================================= */}
      {/* 📱 MOBILE VIEW 📱 */}
      {/* ========================================================= */}
      <main className="md:hidden flex-1 pb-20">
        
        {isMobileReading && activePost ? (
          
          /* 🚨 FIXED: FULL READING VIEW (Mobile) 🚨 */
          <div className="max-w-[900px] mx-auto px-4 py-8">
            <button 
              onClick={() => setIsMobileReading(false)} 
              className="text-[#ef5e33] font-black uppercase text-xs tracking-widest mb-6 flex items-center gap-2 bg-transparent border-none cursor-pointer"
            >
              <span className="text-lg">←</span> Back to Articles
            </button>

            <div className="bg-white rounded-[2rem] shadow-sm border border-gray-100 overflow-hidden">
              
              {/* Image without overlay text */}
              <div className="w-full h-[250px] overflow-hidden bg-gray-100">
                <img src={getImageUrl(activePost, activePost.file)} alt={activePost.title} className="w-full h-full object-cover" />
              </div>
              
              <div className="p-5 md:p-8">
                
                {/* Title below image */}
                <h1 className="text-2xl font-black text-[#002f34] leading-tight mb-6">{activePost.title}</h1>
                
                {/* Author and Date/Time side by side */}
                <div className="flex flex-col gap-4 mb-8 border-b border-gray-100 pb-6 bg-[#fcfcfc] p-4 rounded-xl border">
                  <div className="flex items-center gap-3">
                    <div className="w-10 h-10 bg-[#002f34] rounded-full flex items-center justify-center text-white font-black shadow-md">
                       {activePost.expand?.author?.name?.charAt(0) || 'A'}
                    </div>
                    <div>
                      <p className="text-[#002f34] text-xs font-black uppercase m-0">{activePost.expand?.author?.name || 'Admin'}</p>
                      <p className="text-gray-400 text-[9px] font-bold uppercase tracking-widest m-0 mt-0.5">Author</p>
                    </div>
                  </div>
                  
                  <div className="flex items-center gap-2 pt-3 border-t border-gray-200">
                    <p className="text-gray-400 text-[9px] font-bold uppercase tracking-widest m-0">Published:</p>
                    <p className="text-[#ef5e33] text-xs font-black uppercase m-0">
                      {new Date(activePost.publish_date || activePost.created).toLocaleString('en-IN', { year: 'numeric', month: 'short', day: 'numeric', hour: '2-digit', minute: '2-digit', hour12: true })}
                    </p>
                  </div>
                </div>

                <div className="blog-rich-text text-sm" dangerouslySetInnerHTML={{ __html: activePost.content }} />
                
                {/* PREV / NEXT BUTTONS */}
                <div className="flex justify-between items-center mt-10 pt-6 border-t border-gray-100">
                  <button onClick={handlePrev} disabled={!prevPost} className={`px-4 py-3 rounded-xl font-black text-[10px] uppercase tracking-widest transition-colors ${prevPost ? 'bg-[#002f34] text-white shadow-md' : 'bg-gray-100 text-gray-400'}`}>❮ Prev</button>
                  <button onClick={handleNext} disabled={!nextPost} className={`px-4 py-3 rounded-xl font-black text-[10px] uppercase tracking-widest transition-colors ${nextPost ? 'bg-[#ef5e33] text-white shadow-md' : 'bg-gray-100 text-gray-400'}`}>Next ❯</button>
                </div>

              </div>
            </div>
          </div>

        ) : (
          
          /* MAIN BLOG LIST VIEW (Mobile) */
          <>
            <section className="bg-[#002f34] text-white pt-16 pb-24 px-6 text-center relative overflow-hidden">
              <div className="absolute inset-0 opacity-10 bg-[radial-gradient(circle_at_center,_var(--tw-gradient-stops))] from-white via-transparent to-transparent"></div>
              <div className="relative z-10">
                <h1 className="text-4xl font-black uppercase tracking-tighter mb-3">Bah! <span className="text-[#ef5e33] italic">Autonauts</span></h1>
                <p className="text-gray-300 font-medium text-sm max-w-2xl mx-auto">Your ultimate destination for the latest automotive news.</p>
              </div>
            </section>

            <div className="px-4 -mt-12 relative z-20">
              {loading ? (
                <div className="text-center py-20 font-bold text-gray-500 bg-white rounded-3xl shadow-sm">Loading...</div>
              ) : posts.length === 0 ? (
                <div className="text-center py-20 font-bold text-gray-500 bg-white rounded-3xl shadow-sm">No blog posts found.</div>
              ) : (
                <div className="flex flex-col gap-6">
                  {posts.map((post) => (
                    <div 
                      key={post.id} 
                      onClick={() => handleMobilePostClick(post)}
                      className="bg-white rounded-3xl shadow-md overflow-hidden flex flex-col group cursor-pointer" 
                    >
                      <div className="h-48 overflow-hidden relative">
                        <img src={getImageUrl(post, post.file)} alt={post.title} className="w-full h-full object-cover" />
                      </div>
                      <div className="p-5 flex flex-col flex-1">
                        <p className="text-gray-400 text-[10px] font-bold uppercase tracking-widest mb-2">
                          🗓️ {new Date(post.publish_date || post.created).toLocaleDateString('en-IN', { year: 'numeric', month: 'short', day: 'numeric' })}
                        </p>
                        <h3 className="text-lg font-black text-[#002f34] leading-snug mb-2">{post.title}</h3>
                        <p className="text-gray-500 text-xs font-medium line-clamp-2 mb-4">{stripHtml(post.content)}</p>
                        <div className="mt-auto pt-3 border-t border-gray-100 flex items-center justify-between">
                          <span className="text-[#002f34] font-black text-[9px] uppercase tracking-widest flex items-center gap-2">
                             <span className="w-5 h-5 bg-[#f4f7f6] rounded-full flex items-center justify-center text-[#ef5e33] text-[10px]">👤</span> 
                             {post.expand?.author?.name || 'Admin'}
                          </span>
                          <span className="text-[#ef5e33] font-black text-[10px] uppercase tracking-widest">Read →</span>
                        </div>
                      </div>
                    </div>
                  ))}
                </div>
              )}
            </div>
          </>
        )}
      </main>

      <Footer setView={setView} />
    </div>
  );
}

export default Blogs;